import { useTranslation } from "react-i18next";

import { Button } from "../../components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../../components/ui/dialog";

interface ForceExitWarningModalProperties {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
}

function ForceExitWarningModal({ open, onOpenChange, onConfirm }: ForceExitWarningModalProperties) {
  const { t } = useTranslation();

  const handleConfirm = async () => {
    await onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <div className="gap-4 space-y-4">
          <div>
            <DialogTitle className="text-lg font-semibold">
              {t("forceExit.warning.heading", { defaultValue: "CAPS WARNING" })}
            </DialogTitle>
            <DialogDescription className="sr-only">
              {t("forceExit.warning.description", {
                defaultValue: "Force exit warning",
              })}
            </DialogDescription>
          </div>
          <p className="text-sm">
            {t("forceExit.warning.message", {
              defaultValue:
                "Dealer has canceled the pre-approval request. You will be removed from the deal and the dealer will be notified of any changes that you have already made.",
            })}
          </p>
          <div className="flex justify-end gap-2">
            <Button type="button" size="sm" onClick={() => void handleConfirm()}>
              {t("forceExit.warning.ok", { defaultValue: "OK" })}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ForceExitWarningModal;
